import React from 'react';
import { cn } from '@/lib/utils';
import { TextColors } from '@/types/types';

type TitleProps = {
  children: React.ReactNode;
  type: 'h1' | 'h2' | 'newh2' | 'newh3' | 'h3' | 'h4' | 'h5' | 'h6';
  color?: TextColors;
  className?: string;
};

const colorMap: Record<string, string> = {
  'base-blue-dark': 'text-blue-scale-900',
  'base-blue': 'text-foreground',
  blue: 'text-primary',
  red: 'text-destructive',
  disabled: 'text-muted-foreground',
  white: 'text-white',
  black: 'text-black',
  'base-grey': 'text-muted-foreground',
};

const typeMap: Record<string, string> = {
  h1: 'text-[44px] leading-[128%] font-medium',
  h2: 'text-[30px] leading-[120%] font-normal',
  newh2: 'text-[26px] leading-[120%] font-semibold',
  newh3: 'text-[26px] leading-[150%] font-medium',
  h3: 'text-[22px] leading-[124%] font-semibold',
  h4: 'text-lg leading-[132%] font-bold',
  h5: 'text-sm leading-[125%] font-normal',
  h6: 'text-xs font-normal',
};

function TitleText({ type = 'h1', children, color = 'base-blue', className }: TitleProps) {
  const Tag = type === 'newh2' ? 'h2' : type === 'newh3' ? 'h3' : type;
  return (
    <Tag className={cn(typeMap[type], colorMap[color] ?? 'text-foreground', className)}>
      {children}
    </Tag>
  );
}

export { TitleText };
